import "./PediatricDentistry.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TeachingProcessSteps from "./sections/TeachingProcessSteps";
import GetInTouch from "./sections/GetInTouch";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function PediatricDentistryPage() {
  return <div>
      <Header />
      <Hero />
      <TeachingProcessSteps />
      <GetInTouch />
      <Projects />
      <Footer />
    </div>;
}